import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=3546e581&scoped=true"
import script from "./Rules.vue?vue&type=script&lang=js"
export * from "./Rules.vue?vue&type=script&lang=js"
import style0 from "./Rules.vue?vue&type=style&index=0&id=3546e581&prod&lang=scss&scoped=true"
import style1 from "./Rules.vue?vue&type=style&index=1&id=3546e581&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3546e581",
  null
  
)

export default component.exports